import styled, { css } from 'styled-components';
import {
  borderBlue,
  justifyContentSpaceBetween,
} from '../../styles/commonStyles';

function SingleSwitch({
  location,
  machineName,
  application,
  switches,
  displaySwitches,
}) {
  return (
    <Wrapper>
      <Div>
        <Div1>
          <Circle></Circle>
          <Location>{`${location}  ${machineName}`}</Location>
        </Div1>
        <SwitchHeatingSystem>{application}</SwitchHeatingSystem>
      </Div>
    </Wrapper>

  );
}

export default SingleSwitch;

const Wrapper = styled.div``;

const Div = styled.div`
  width: 274px;
  height: 24px;

  ${borderBlue}

  border-radius: 16px;
  opacity: 1;
  ${justifyContentSpaceBetween}
`;

const Div1 = styled.div`
  display: flex;
  align-items: center;
`;

const Circle = styled.div`
  width: 10px;
  height: 10px;
  margin-left: 10px;
  margin-right: 5px;
  border-radius: 50%;
  background-color: #ffff;
  color: #ffff;
`;
const Location = styled.p`
  font-size: 8px;
  margin-left: 4px;
  letter-spacing: 0.8px;
  color: #ffffff;
  opacity: 1;
`;
const SwitchHeatingSystem = styled.p`
  text-transform: capitalize;
  font-size: 8px;
  margin-right: 4px;
  letter-spacing: 0.8px;
  color: #ffffff;
  opacity: 1;
`;
